module.exports = __webpack_public_path__ + "static/media/1.cc583312.JPG";